import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { ProjectInstance } from '../../../utils/ProjectInstance';
import { LayoutType } from '../../../constants/LayoutConstants';
import { ProjectManagerStore } from '../../../stores/ProjectManagerStore';
import { SelectBoxStore } from '../../../stores/SelectBoxStore';
import { ProjectManagerActions } from '../../../actions/ProjectManagerActions';
import { ClickButton } from '../../ClickButton';
import { SceneActions } from '../../../actions/SceneActions';
import { CenteredImage } from '../../CenteredImage';
import { UIHelper } from '../../../utils/UIHelper';

interface ProjectTileState {
    active: boolean;
    selectable: boolean;
    selectBoxOpen: boolean;
}

interface ProjectTileProps extends React.Props<ProjectTile> {
    project: ProjectInstance | null;
    disabled: boolean;
    layoutType: LayoutType;
    maybeUnloadable: boolean;
    last?: boolean;
}

export class ProjectTile extends BaseComponent<ProjectTileProps, ProjectTileState> {
    public componentWillMount(): void {
        this.addStoreListener(ProjectManagerStore, this.onChange);
        this.addStoreListener(SelectBoxStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        if (this.props.project == null) {
            return (
                <ClickButton className={this.getCSSClass()} callback={SceneActions.newScene}>
                    <div className="project-image"/>
                    <div className="project-name">{t('New')}</div>
                </ClickButton>
            );
        }
        return (
            <ClickButton className={this.getCSSClass()} callback={this.setActive}>
                <div className="project-image">
                    <CenteredImage className="" src={this.props.project.image} />
                </div>
                <div className="project-name">{UIHelper.middleEllipsis(this.props.project.name ? this.props.project.name : t('Unnamed'), 20)}</div>
                <div className="project-info-date">{UIHelper.toDateString(this.props.project.date)}</div>
            </ClickButton>
        );
    }

    protected onChange = (): void => {
        let active: boolean = false;
        if (
            this.props.project != null &&
            ProjectManagerStore.getState().selectedProjects.indexOf(this.props.project.id) !== -1
        ) {
            active = true;
        }
        this.setState({
            active,
            selectable: ProjectManagerStore.getState().editMode,
            selectBoxOpen: (
                this.props.project != null &&
                (SelectBoxStore.getState().sender === this.props.project.id) &&
                SelectBoxStore.getState().options.length > 0
            )
        });
    };

    protected setActive = (): void => {
        if (this.props.project != null && !this.props.disabled) {
            if (this.state.selectable) {
                ProjectManagerActions.toggleProjectSelection(this.props.project.id);
            } else {
                ProjectManagerActions.loadProject(this.props.project.id, this.props.project.attributes);
            }
        }
    };

    protected getCSSClass = (): string => {
        let tTileCSSClass: string = 'project-tile';
        if (this.state.active) {
            tTileCSSClass += ' active';
        }
        if (this.props.disabled) {
            tTileCSSClass += ' disabled';
        }
        if (this.props.project == null) {
            tTileCSSClass += ' new-project';
        }
        if (this.props.maybeUnloadable) {
            tTileCSSClass += ' half-opacity';
        }
        return tTileCSSClass;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/projectmanager/ProjectTile.tsx